// Hardcoded expiry date - this is currently always fixed and not used in the current flow, but required on the endpoint request.
export const FIXED_EXPIRY_DATE = '4925';

export const CREDIT_TRANSACTION_TYPES = ['reload', 'refund', 'transfer_in', 'activation'];

// Gift card BIN ranges that require CVV2 instead of PIN
export const GIFT_CARD_CVV2_BIN_PREFIXES = ['589629329', '589629332'];

// Gift card BIN ranges that require 4-digit PIN
export const GIFT_CARD_PIN_BIN_PREFIXES = [
  '589629304',
  '589629305',
  '58962913',
  '589629429',
  '589629435',
  '589629436',
  '589629437',
  '589629487',
];

export type GiftCardSecurityFieldType = 'pin' | 'cvv2' | 'none';

// Calculate max prefix length from existing prefixes to determine when we can decisively say a card doesn't match
const ALL_GIFT_CARD_BIN_PREFIXES = [
  ...GIFT_CARD_CVV2_BIN_PREFIXES,
  ...GIFT_CARD_PIN_BIN_PREFIXES,
];
const MAX_BIN_PREFIX_LENGTH = Math.max(...ALL_GIFT_CARD_BIN_PREFIXES.map(prefix => prefix.length));

/**
 * Determines the security field type (PIN or CVV2) based on the gift card number BIN prefix.
 * - Returns 'pin' by default (when card number is shorter than max prefix length or matches PIN BIN prefixes)
 * - Returns 'cvv2' for cards starting with CVV2 BIN prefixes
 * - Returns 'none' when card number is long enough to determine it doesn't match any known prefix
 */
export const getGiftCardSecurityFieldType = (cardNumber: string): GiftCardSecurityFieldType => {
  const cleanCardNumber = cardNumber.replace(/\s/g, '');

  // Check for CVV2 prefixes first
  if (GIFT_CARD_CVV2_BIN_PREFIXES.some(prefix => cleanCardNumber.startsWith(prefix))) {
    return 'cvv2';
  }

  // Check for PIN prefixes
  if (GIFT_CARD_PIN_BIN_PREFIXES.some(prefix => cleanCardNumber.startsWith(prefix))) {
    return 'pin';
  }

  // If card number is long enough to determine it doesn't match any prefix, hide the field
  if (cleanCardNumber.length >= MAX_BIN_PREFIX_LENGTH) {
    return 'none';
  }

  // Default: show PIN field while user is still typing
  return 'pin';
};
